/**
 * @module interface
 */
export interface V2TimFriendGroup {
    name?: string;
    friendCount?: number;
    friendIDList?: string[];
}
